var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"custom-page"}},[_c('ClientOnly',[(_vm.container && _vm.container.html)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.container.html)}}):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }